import { useMonitorMicAndCameraPermissions } from './useMonitorPermissions';

type CanProceedInterviewStepProps = {
  interviewHasVideo: boolean;
  currentQuestionTypeIsVideo: boolean;
};

export const useCanProceedInterviewStep = ({
  interviewHasVideo,
  currentQuestionTypeIsVideo,
}: CanProceedInterviewStepProps) => {
  const { cameraDenied, micDenied } = useMonitorMicAndCameraPermissions();

  const canNotProceed = cameraDenied || micDenied;

  const canProceed = !canNotProceed;

  const canProceedInterviewStep: boolean = !interviewHasVideo
    ? true
    : !currentQuestionTypeIsVideo
      ? true
      : canProceed;

  return {
    canProceedInterviewStep,
    cameraDenied,
    micDenied,
  };
};
